import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import L from 'leaflet';
import Modal from 'react-modal';
import { format, parseISO } from 'date-fns';
import { ptBR } from 'date-fns/locale';
import { MdArrowBack, MdClose } from 'react-icons/md';
import BuscarSuporte from '../../services/Suporte/BuscarSuporte';

// Componentes
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import * as S from './styles';

// CSS do Leaflet
import 'leaflet/dist/leaflet.css';

// Configuração do ícone padrão do Leaflet
const defaultIcon = L.icon({
  iconUrl: 'https://unpkg.com/leaflet@1.7.1/dist/images/marker-icon.png',
  shadowUrl: 'https://unpkg.com/leaflet@1.7.1/dist/images/marker-shadow.png',
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41],
});



function DeviceInfo() {
    const [deviceInfos, setDeviceInfos] = useState([]);
    const [selectedInfo, setSelectedInfo] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        // Simula o carregamento dos dados de uma API
        // TODO: Substituir por uma chamada de API real
        fetchSupportData();
    }, []);

    const handleItemClick = (info) => {
        setSelectedInfo(info);
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
        setSelectedInfo(null);
    };

    const formatarData = (timestamp) => {
        try {
            return format(parseISO(timestamp), "dd/MM/yyyy 'às' HH:mm:ss", { locale: ptBR });
        } catch (error) {
            return "Data inválida";
        }
    };
    const fetchSupportData = async () => {
        try {
            const data = await BuscarSuporte();
            setDeviceInfos(data);
        } catch (error) {
            console.error("Erro ao buscar dados de suporte:", error);
            // Trate o erro conforme necessário, como exibir uma mensagem para o usuário
        }
        // setDeviceInfos(mockData);
       
    };

    return (
        <S.Container>
            <Header />
            <S.BackButton onClick={() => navigate('/marketdo')}>
                <MdArrowBack style={{ marginRight: '8px' }} />
                Voltar
            </S.BackButton>
            <S.Title>Logs de Dispositivos</S.Title>

            <S.ListContainer>
                {deviceInfos.length > 0 ? deviceInfos.map((info) => (
                    <S.ListItem key={info._id.$oid} onClick={() => handleItemClick(info)}>
                        <p><strong>Usuário:</strong> {info.userInfo.username}</p>
                        <p><strong>App:</strong> {info.appInfo.appName} v{info.appInfo.appVersion}</p>
                        <p><strong>Dispositivo:</strong> {info.deviceInfo.manufacturer} {info.deviceInfo.modelName}</p>
                        <p><strong>Data:</strong> {formatarData(info.timestamp)}</p>
                    </S.ListItem>
                )) : (
                    <p>Nenhum log encontrado.</p>
                )}
            </S.ListContainer>

            {selectedInfo && (
                <Modal
                    isOpen={isModalOpen}
                    onRequestClose={closeModal}
                    style={S.customModalStyles}
                    contentLabel="Detalhes do Log"
                    appElement={document.getElementById('root') || undefined}
                >
                    <S.ModalHeader>
                        <h2>Detalhes do Log</h2>
                        <S.CloseButton onClick={closeModal}><MdClose size={24} /></S.CloseButton>
                    </S.ModalHeader>
                    <S.ModalBody>
                        <S.DetailsSection>
                            <h3>Informações do Usuário</h3>
                            <p><strong>Usuário:</strong> {selectedInfo.userInfo.username}</p>
                            <p><strong>ID Rede:</strong> {selectedInfo.userInfo.idRede}</p>
                            <p><strong>Sessão Restante:</strong> {selectedInfo.userInfo.sessionTimeRemaining}</p>
                            <hr />
                            <h3>Informações do Dispositivo</h3>
                            <p><strong>Plataforma:</strong> {selectedInfo.deviceInfo.platform}</p>
                            <p><strong>Modelo:</strong> {selectedInfo.deviceInfo.modelName}</p>
                            <p><strong>Fabricante:</strong> {selectedInfo.deviceInfo.manufacturer}</p>
                            <p><strong>Versão SO:</strong> {selectedInfo.deviceInfo.osVersion}</p>
                            {selectedInfo.deviceInfo.osName && <p><strong>Nome do SO:</strong> {selectedInfo.deviceInfo.osName}</p>}
                            {selectedInfo.deviceInfo.deviceName && <p><strong>Nome do Dispositivo:</strong> {selectedInfo.deviceInfo.deviceName}</p>}
                            {selectedInfo.deviceInfo.buildVersion && <p><strong>Versão da Build:</strong> {selectedInfo.deviceInfo.buildVersion}</p>}
                            {selectedInfo.deviceInfo.runtimeVersion && <p><strong>Versão do Runtime:</strong> {selectedInfo.deviceInfo.runtimeVersion}</p>}
                            {selectedInfo.deviceInfo.totalMemory && <p><strong>Memória Total:</strong> {selectedInfo.deviceInfo.totalMemory.$numberLong} bytes</p>}
                        </S.DetailsSection>
                        <S.DetailsSection>
                            <h3>Informações Adicionais</h3>
                            {selectedInfo.appInfo && (
                                <>
                                    <p><strong>Nome do App:</strong> {selectedInfo.appInfo.appName}</p>
                                    <p><strong>Versão do App:</strong> {selectedInfo.appInfo.appVersion}</p>
                                    {selectedInfo.appInfo.minimumRequiredBuildNumber && <p><strong>Build Mínima Requerida:</strong> {selectedInfo.appInfo.minimumRequiredBuildNumber}</p>}
                                </>
                            )}
                            {selectedInfo.networkInfo && <p><strong>Tipo de Rede:</strong> {selectedInfo.networkInfo.type}</p>}
                        </S.DetailsSection>
                        <S.MapSection>
                           {selectedInfo.locationInfo?.currentPosition ? (
                                <MapContainer
                                    center={[
                                        selectedInfo.locationInfo.currentPosition.coords.latitude,
                                        selectedInfo.locationInfo.currentPosition.coords.longitude
                                    ]}
                                    zoom={15}
                                >
                                    <TileLayer
                                        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                                        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                                    />
                                    <Marker
                                        position={[
                                            selectedInfo.locationInfo.currentPosition.coords.latitude,
                                            selectedInfo.locationInfo.currentPosition.coords.longitude
                                        ]}
                                        icon={defaultIcon}
                                    >
                                        <Popup>
                                            Localização capturada. <br />
                                            Precisão: {selectedInfo.locationInfo.currentPosition.coords.accuracy.toFixed(2)} metros.
                                        </Popup>
                                    </Marker>
                                </MapContainer>
                           ) : (
                               <div>Informação de localização não disponível.</div>
                           )}
                        </S.MapSection>
                         <S.DetailsSection>
                            <h3>Informações de Localização</h3>
                            {selectedInfo.locationInfo ? (
                                <>
                                    <p><strong>Status da Permissão:</strong> {selectedInfo.locationInfo.permissionStatus}</p>
                                    {selectedInfo.locationInfo.providerStatus && (
                                        <>
                                            <p><strong>Modo de Background:</strong> {selectedInfo.locationInfo.providerStatus.backgroundModeEnabled ? "Ativado" : "Desativado"}</p>
                                            <p><strong>GPS Disponível:</strong> {selectedInfo.locationInfo.providerStatus.gpsAvailable ? "Sim" : "Não"}</p>
                                            <p><strong>Serviços de Localização:</strong> {selectedInfo.locationInfo.providerStatus.locationServicesEnabled ? "Ativados" : "Desativados"}</p>
                                            <p><strong>Rede Disponível:</strong> {selectedInfo.locationInfo.providerStatus.networkAvailable ? "Sim" : "Não"}</p>
                                            <p><strong>Modo Passivo:</strong> {selectedInfo.locationInfo.providerStatus.passiveAvailable ? "Ativado" : "Desativado"}</p>
                                        </>
                                    )}
                                    {selectedInfo.locationInfo.currentPosition && (
                                        <>
                                            <p><strong>Precisão:</strong> {selectedInfo.locationInfo.currentPosition.coords.accuracy.toFixed(2)} metros</p>
                                            <p><strong>Longitude:</strong> {selectedInfo.locationInfo.currentPosition.coords.longitude}</p>
                                            <p><strong>Altitude:</strong> {selectedInfo.locationInfo.currentPosition.coords.altitude}</p>
                                            <p><strong>Direção:</strong> {selectedInfo.locationInfo.currentPosition.coords.heading}</p>
                                            <p><strong>Latitude:</strong> {selectedInfo.locationInfo.currentPosition.coords.latitude}</p>
                                            <p><strong>Precisão da Altitude:</strong> {selectedInfo.locationInfo.currentPosition.coords.altitudeAccuracy}</p>
                                            <p><strong>Velocidade:</strong> {selectedInfo.locationInfo.currentPosition.coords.speed}</p>
                                            <p><strong>Mocked:</strong> {selectedInfo.locationInfo.currentPosition.mocked ? "Sim" : "Não"}</p>
                                            {selectedInfo.locationInfo.currentPosition.timestamp && (
                                                <p><strong>Timestamp:</strong> {selectedInfo.locationInfo.currentPosition.timestamp.$numberLong}</p>
                                            )}
                                        </>
                                    )}
                                </>
                            ) : (
                                <p>Informações de localização não disponíveis.</p>
                            )}
                        </S.DetailsSection>


                        <S.DetailsSection>
                            <h3>Informações Completas (JSON)</h3>
                            <pre style={{ whiteSpace: 'pre-wrap', fontSize: '12px' }}>
                                {JSON.stringify(selectedInfo, null, 2)}
                            </pre>
                        </S.DetailsSection>
                    </S.ModalBody>
                </Modal>
            )}

            <Footer />
        </S.Container>
    );
}

export default DeviceInfo;